export default __webpack_public_path__ + "static/media/FFM.08e89f64.glb";